module.exports = __webpack_public_path__ + "img/vip-icon1.bedff650.png";